import { createContext, useContext } from 'react';
import { AppInitializerContext as AppInitializerContextType } from './types';

export const AppInitializerContext = createContext<AppInitializerContextType>({
    isHttpServiceReady: false,
    isReady: false,
});

export const useAppInitializer = () => useContext(AppInitializerContext);
